import { Link } from 'react-router-dom';
import { cn } from '../../utils/format';

/**
 * Logo de marca.
 *
 * Hay dos archivos porque el logotipo es gris: sobre fondo oscuro se usa una
 * versión con los grises aclarados (el naranja queda igual). El modo oscuro se
 * resuelve por CSS; `onDark` es para los fondos oscuros que existen aunque el
 * sitio esté en modo claro (footer, hero, pantallas de ingreso).
 *
 * @param onDark  forzar la versión clara
 * @param to      a dónde lleva (mayorista vuelve a /mayorista, no a la tienda)
 */
export default function Logo({ className, onClick, onDark = false, to = '/' }) {
  const img = 'h-12 w-auto sm:h-14';

  return (
    <Link
      to={to}
      onClick={onClick}
      aria-label="MS Fabrics — ir al inicio"
      className={cn('inline-flex select-none items-center', className)}
    >
      <img
        src="/brand/logo.png"
        alt=""
        width={900}
        height={355}
        className={cn(img, onDark ? 'hidden' : 'dark:hidden')}
      />
      <img
        src="/brand/logo-dark.png"
        alt=""
        width={900}
        height={355}
        className={cn(img, onDark ? 'block' : 'hidden dark:block')}
      />
    </Link>
  );
}
